import { gql } from "@apollo/client";

export const MUTATION_CREATE_HEALTH_AFFILIATION = gql`
  mutation CreateHealthAffiliation(
    $documentNumber: String!
    $documentTypeId: String!
    $documentExpirationDate: String!
    $email: String!
    $stateId: Int!
    $cityId: String!
    $epsId: Int!
    $gender: GENDER_TYPE!
    $birthDate: String!
    $dependentChildren: Boolean!
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
    $secondaryPhoneNumber: String!
    $termsAndConditionsAcceptedId: String!
    $optionalPhoneNumber: String
    $neighborhood: String
    $termsAndConditionAdultAcceptedId: String
    $older: Boolean!
    $documentAdultTypeId: String
    $firstNameAdult: String
    $lastNameAdult: String
    $phoneNumberAdult: String
    $documentNumberAdult: String
    $files: [Upload!]!
    $token: String!
  ) {
    createHealthAffiliation(
      documentNumber: $documentNumber
      documentTypeId: $documentTypeId
      documentExpirationDate: $documentExpirationDate
      email: $email
      stateId: $stateId
      cityId: $cityId
      epsId: $epsId
      gender: $gender
      birthDate: $birthDate
      dependentChildren: $dependentChildren
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      secondaryPhoneNumber: $secondaryPhoneNumber
      termsAndConditionsAcceptedId: $termsAndConditionsAcceptedId
      optionalPhoneNumber: $optionalPhoneNumber
      neighborhood: $neighborhood
      termsAndConditionAdultAcceptedId: $termsAndConditionAdultAcceptedId
      older: $older
      documentAdultTypeId: $documentAdultTypeId
      firstNameAdult: $firstNameAdult
      lastNameAdult: $lastNameAdult
      phoneNumberAdult: $phoneNumberAdult
      documentNumberAdult: $documentNumberAdult
      files: $files
      token: $token
    ) {
      message
      data {
        id
      }
    }
  }
`;
